import { useVodAnalytics } from "./useVodAnalytics";
import { useActiveUsers } from "./useActiveUsers";
import { useAnalyticsParams } from "./useAnalyticsParams";

export const useViewershipDashboard = (
  dateRange,
  defaultChannel,
  usersData = {},
  isContentPartner = false,
  enabled = true
) => {
  const { totalUsers } = usersData || {};
  const { params, skip } = useAnalyticsParams(dateRange, defaultChannel);
  const effectiveSkip = skip || !enabled;

  const {
    loading: vodLoading,
    viewedMinutesData,
    viewsData,
  } = useVodAnalytics({ params, skip: effectiveSkip, dateRange, isContentPartner });

  const {
    loading: activeUsersLoading,
    loadingStates: activeUsersLoadingStates,
    activeUsersData,
    newRegistrationsData,
    topShows,
    liveViewers,
    activeUsersStats,
  } = useActiveUsers({ params, skip: effectiveSkip, dateRange, isContentPartner });

  return {
    loading: enabled ? (vodLoading || activeUsersLoading) : false,
    loadingStates: enabled
      ? {
          totalUsers: Boolean(usersData?.loading),
          liveViewers: Boolean(activeUsersLoadingStates?.liveViewers),
          activeUsers: Boolean(
            activeUsersLoadingStates?.activeUsers ||
            activeUsersLoadingStates?.activeUsersStats
          ),
          newUsers: Boolean(activeUsersLoadingStates?.newUsers),
          viewedMinutes: Boolean(vodLoading),
          views: Boolean(vodLoading),
          topShows: Boolean(activeUsersLoadingStates?.topViewed),
        }
      : {
          totalUsers: false,
          liveViewers: false,
          activeUsers: false,
          newUsers: false,
          viewedMinutes: false,
          views: false,
          topShows: false,
        },
    viewedMinutesData,
    viewsData,
    activeUsersData,
    newRegistrationsData,
    topShows,
    totalUsers,
    liveViewers,
    activeUsersStats,
  };
};

export default useViewershipDashboard;
